import { Component, Input, OnInit } from '@angular/core';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { Store } from '@ngrx/store';
import { IReducers } from 'app/store/reducers';
import { openDialog, openSnackbar } from 'app/store/actions/page.action';
import { ContentService } from '../../../store/services/content.service';

@Component({
  selector: 'app-request-help-button',
  templateUrl: './request-help-button.component.html',
  styleUrls: ['./request-help-button.component.scss'],
})
export class RequestHelpButtonComponent implements OnInit {

  @Input() disabled: boolean = false;

  @Input() contentGroupID: number;

  @Input() contentGroupName: string;

  requestHelpButton: Button = {
    color: ButtonColor.BLUE,
    size: ButtonSize.SMALL,
    text: 'Request Help with Content',
    onClick: () =>
      this.store.dispatch(
        openDialog({
          dialogData: {
            content:
              'Your content is very important to the success of your campaign. For content tips and examples, visit our Helpcenter from the support tab. Search "Content Tips". If you would like assistance from one of our content specialists, click Request Help with Content.',
            title: 'Request help with content',
            canClose: true,
            dialogMinWidth: '700px',
            buttons: [
              {
                color: ButtonColor.BLUE,
                size: ButtonSize.SMALL,
                text: 'Request Help with Content',
                onClick: (dialog) => this.contentService.requestContentHelp(this.contentGroupID, this.contentGroupName)
                  .subscribe(() => {
                    this.store.dispatch(openSnackbar({
                      snackbarData: {
                        data: {
                          message: 'Help with the content is requested!',
                          type: 'success',
                        },
                      },
                    }));
                    dialog.closeDialog();
                  }, err => {
                    this.store.dispatch(openSnackbar({
                      snackbarData: {
                        data: {
                          message: err.error,
                          type: 'error',
                        },
                      },
                    }));
                    dialog.closeDialog();
                  }),
              },
            ],
          },
        }),
      ),
  };

  constructor(
    private readonly store: Store<IReducers>,
    private readonly contentService: ContentService,
  ) {
  }

  ngOnInit() {
  }
}
